export const fetchFromSubgraph = async <T>({
  subgraphUrl,
  query,
  variables,
}: {
  subgraphUrl: string;
  query: string;
  variables?: unknown;
}): Promise<{ data: T }> => {
  const res = await fetch(subgraphUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ query, variables }),
  });
  const resBody: {
    data: T;
  } = await res.json();
  if (!res.ok) {
    throw new Error(
      `Failed to fetch from subgraph ${subgraphUrl}: ${res.statusText}`,
    );
  }
  return resBody;
};
